import { actions, elements } from '@ecosystem/newron-design-system';
import { EditGroupMode, GroupState } from '@models/OpportunityReview';
import * as styles from '@utils/tableViewscss/TableViewBoard.module.scss';
import classnames from 'classnames';
import { isShareGroupButtonDisable } from '@utils/TableUtils';

interface GroupRowProps {
  groupState: GroupState;
  isRowHovered: boolean | undefined;
  toggleGroupDown: boolean;
  handleGroupDropdownToggle: () => void;
  openDeleteModalGroup: () => void;
  segment: string;
  isEditGroupMode: EditGroupMode;
  openShareModalGroup: () => void;
  isPreferenceOwner?: boolean;
}

const OpportunityReviewGroupTableCell: React.FC<GroupRowProps> = ({
  groupState,
  isRowHovered,
  toggleGroupDown,
  handleGroupDropdownToggle,
  openDeleteModalGroup,
  segment,
  isEditGroupMode,
  openShareModalGroup,
  isPreferenceOwner,
}) => {
  const { Menu, IconButton } = actions;
  const { Icon } = elements;
  const { ChevronUp, ChevronDown, AddGroup, Share, Delete } = IconButton.icons;
  const isDropdownDisabled = groupState.isGroupEmpty ?? isEditGroupMode.isEditMode;

  const dropdownIcon = toggleGroupDown && !isEditGroupMode.isEditMode ? <ChevronUp /> : <ChevronDown />;

  const moreMenu = isRowHovered ? (
    <div className={styles.TableViewboard__TableCell__MoreMenu}>
      <Menu isDisabled={isEditGroupMode.isEditMode}>
        <Menu.MoreButton />
        <Menu.List>
          {groupState.isPreferenceOwner ? (
            <>
              <Menu.Item onSelect={groupState?.enableIsEditGroupMode!}>
                <Icon>
                  <AddGroup />
                </Icon>
                {`Add to group`}
              </Menu.Item>
              <Menu.Item onSelect={openShareModalGroup} isDisabled={isShareGroupButtonDisable(groupState)}>
                <Icon>
                  <Share />
                </Icon>
                Share group
              </Menu.Item>
            </>
          ) : (
            <></>
          )}
          <Menu.Item onSelect={openDeleteModalGroup}>
            <Icon>
              <Delete />
            </Icon>
            Delete group
          </Menu.Item>
        </Menu.List>
      </Menu>
    </div>
  ) : (
    <div className={styles.TableViewboard__TableCell__MoreMenu_padding} />
  );

  return (
    <td key={segment} className={classnames(styles.TableViewboard__TableCell, styles.TableViewboard__TableCell_Total)}>
      <div className={styles.TableViewboard__TableCell__grouping}>
        <IconButton testId="button-icon" onClick={handleGroupDropdownToggle} disabled={isDropdownDisabled}>
          {dropdownIcon}
        </IconButton>
        <p>{segment}</p>
        {moreMenu}
      </div>
    </td>
  );
};

export default OpportunityReviewGroupTableCell;
